import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { CategoryViewComponentDef } from '@df/catalog-ui/category/view/category-view.component.def';
import { ICategoryDataV3 } from '@df/catalog/category/category';
import { IProductDataV2 } from '@df/catalog/product/product';
import { Product } from '../../product/product.decorator';
import { Category } from '../category.decorator';
import { CategoryViewLayoutComponent } from './layout/category-view-layout.component';

@Component({
    selector: 'category-view',
    template: `<category-view-layout [variant]="model?.lpLayoutVariant || 'default'" />`,
    imports: [forwardRef(() => CategoryViewLayoutComponent)],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoryViewComponent extends CategoryViewComponentDef<Category<ICategoryDataV3>, Product<IProductDataV2>> {}
